import React from "react";
//Utils
import { calculateAge, dateToString } from "../../utils";
// Components
import HorizontalCard from "../generic/HorizontalCard";
// Styled
import styled from "styled-components";
// React Router
import { useHistory } from "react-router-dom";
import { context } from "../../contexto";

const CardHermana = styled(HorizontalCard).attrs(props => ({
  
  backgroundColor: props.accesible ? "#F0F8FF" : "#FFF0F0",
  grayscale: props.active ? 0 : 100,
  shadow: props.active ? "0 0px 6px #2a599f !important" : "0 0px 6px #93a1b4 !important"

}))`

  -webkit-filter: grayscale(${props => props.grayscale}); /* Safari 6.0 - 9.0 */
  filter: grayscale(${props => props.grayscale});
  
  :hover {
    box-shadow: ${props => props.shadow};
    background-color: ${props => props.backgroundColor};
  }



`;

const HermanaTarjeta = ({ content, provinciaLogueado, ...props }) => {

  let history = useHistory();

  // Procesamiento de los datos de las hermanas
  let img = content.photo ? `${process.env.REACT_APP_API_URL}/download/usuarios/${content.id}` : "/images/nun.png";
  let imgOnError = "/images/nun.png";
  let title = `${content.name} ${content.firstSurname} ${content.secondSurname}`;
  let years = content.birthdate ? `${dateToString(content.birthdate)}` : "";
  let address = content.birthCountry ? `${content.birthCountry}` : "";

  let body = [
    { img: { url: "/images/address.png", size: 20, title: "País de nacimiento" }, value: address ? address : "No especificada" },
    { img: { url: "/images/birthday-cake.png", size: 20, title: "Fecha nacimiento" }, value: years ? years : "No especificada" },
    { img: { url: "/images/province.png", size: 20, title: "Provincia" }, value: content.sister?.destinations[0] ? content.sister?.destinations[0]?.province.name : "No asignada" },
    { img: { url: "/images/comunidad.png", size: 20, title: "Comunidad" }, value: content.sister?.destinations[0] ? content.sister?.destinations[0]?.community.name : "No asignada" }
  ];

  return (
    <>
      {(props.userLevel === 2 || props.userLevel === 3 || props.userLevel === 8) &&
        <CardHermana active={(content.active && !content.sister.decease)} cardImage={img} title={title} body={body} imgOnError={imgOnError} {...props}></CardHermana>
      }
      {
      //console.log(provinciaLogueado.id + ' logueado provincia ' + content.sister?.destinations[0]?.provinceId)
    }
      {(props.userLevel >= 9) &&
        <CardHermana
          accesible={(provinciaLogueado?.id === content.sister?.destinations[0]?.provinceId) || props.userLevel >= 10 ? true : false}
          active={content.active && !content.sister.decease}
          onClick={((props.userLevel === 9 && provinciaLogueado?.id === content.sister?.destinations[0]?.provinceId) || props.userLevel > 9) ?
            () => { history.push(`hermanas/${content.id}`); }
            :
            null
          }
          cardImage={img} title={title} body={body} imgOnError={imgOnError} {...props}>
        </CardHermana>
      }

    </>

  );
};

export default HermanaTarjeta;
